import { Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-asset-error-log',
  templateUrl: './asset-error-log.component.html',
  styleUrls: ['./asset-error-log.component.scss'],
})
export class AssetErrorLogComponent implements OnInit {

  buttonColorName: any
  updateLogsData: any = [];
  deleteLogsData: any = [];
  selectedTypeTabIndex: any;
  selectedTypeTabName: any = 'Deleted Asset';
  EmployeeSummaryData: any;
  loggedInUserCompanyID: any;
  loggedInUserId: any;
  loggedInCompanyFiscalyear: any | null;
  pmsYears: any = []
  selectedYearForCompetency: any = null;
  fromYear: any;
  toYear: any;

  constructor(public sharedService: SharedService, public router: Router, private httpService: HttpService, private config: Config, private encryptionService: EncryptionService) { }

  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.getpmsyearlist();
    this.getEmployee();


    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');

    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

  }
  formatedataVariable = formatText;
  previousPage() {
    this.router.navigate(['/home/hrportal/asset-management']);
  }
  onClickVariablePaySetup(event: any) { }
  nextPage() {

  }
  onClickBreadcrumExpence() {
    this.router.navigate(['/home/hrportal/asset-management']);

  }

  tableDataDetails: any = [];
  onSortAssending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] < b[sortKey]) return -1;
      if (a[sortKey] > b[sortKey]) return 1;
      return 0;
    });
  }
  onSortDesending(sortKey: any): void {
    this.updateLogsData.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => {
      if (a[sortKey] > b[sortKey]) return -1;
      if (a[sortKey] < b[sortKey]) return 1;
      return 0;
    });
  }

  tabTypeChanged(event: MatTabChangeEvent) {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;

    this.selectedYearForCompetency = this.apiYear;

    if (this.selectedTypeTabName == 'Updated Asset') {

      this.viewLogsDetails();
    } else {
      this.viewDeleteLogsDetails();
    }

  }



  taskColumnHeaderInfo = [
    { label: 'Field', isMandatory: false, sortingName: 'fieldName' },
    { label: 'Old Value', isMandatory: false, sortingName: 'oldValue' },
    { label: 'New Value', isMandatory: false, sortingName: 'newValue' },
    { label: 'Changed By', isMandatory: false, sortingName: 'createdAt' },
    { label: 'Changed On', isMandatory: false, sortingName: 'updatedAt' }
  ];
  taskDeletedHeaderInfo = [
    { label: 'Asset Department Name', isMandatory: true, sortingName: 'assetDepartmentName' },
    { label: 'Delete Date', isMandatory: true, sortingName: 'createdAt' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Fiscal Year', isMandatory: true, sortingName: 'year' },
    { label: 'Year', isMandatory: true, sortingName: 'year' },
    { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
    { label: 'Bands', isMandatory: true, sortingName: 'bands' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'authorityName' },
    { label: 'Authority Department', isMandatory: true, sortingName: 'authorityDepartment' },
  ];

  apiYear: any;
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];

  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };

  //       // Get current year
  //       const currentYear = new Date().getFullYear();

  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);

  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });

  //     this.pmsYears?.forEach((ele: any) => {
  //       const currentYear = new Date().getFullYear();
  //       let yearValue = '';

  //       //  if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //       //    yearValue = `${currentYear}-${currentYear}`;
  //       //  } else {
  //       //    yearValue = `${currentYear}-${currentYear + 1}`;
  //       //  }
  //       if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
  //         yearValue = `${currentYear}-${currentYear}`; // Calendar year
  //       } else if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
  //         if (new Date().getMonth() < 3) {
  //           // If it's Jan, Feb, or Mar, we're in the previous fiscal year
  //           yearValue = `${currentYear - 1}-${currentYear}`;
  //         } else {
  //           // From Apr onwards, it's the current fiscal year
  //           yearValue = `${currentYear}-${currentYear + 1}`;
  //         }
  //       }
       
  //       if (ele?.year == yearValue) {
  //         this.selectedYearForCompetency = ele?.year;
  //         this.apiYear = ele.year;

  //         var test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
      
  //     });


  //   });

  // }
  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);

    });
  }
  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYearForCompetency = selectedYearObj?.year;
          // this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
          // this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
          // this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
          // this.selectedYearForGraphSix = selectedYearObj?.year;
          // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
          // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

      let test = selectedYearObj?.year.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
    }
  }

  //viewReimbursementByYear
  viewReimbursementByYear(year: any) {

    if (this.selectedTypeTabName == 'Updated Asset') {

      this.viewLogsDetails();
    } else {
      this.viewDeleteLogsDetails();
    }
  }

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      this.viewLogsDetails();
      this.viewDeleteLogsDetails();
    })
  }

  viewLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsForAssetUpdate}/${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        this.updateLogsData = result.data;

        this.updateLogsData.forEach((ele: any) => {
          // Ensure EmployeeSummaryData is defined and is an array
          if (!this.EmployeeSummaryData || !Array.isArray(this.EmployeeSummaryData)) {
            console.error('EmployeeSummaryData is not defined or not an array');
            return;
          }

          // Get the name of the HR/Admin who changed the log
          const matchingHRAdmin = this.EmployeeSummaryData
            .filter((employee: { id: any }) => employee.id === ele.changedByUserId)
            .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

          ele.changedByUserName = matchingHRAdmin.length > 0 ? matchingHRAdmin[0] : '';

          if (ele.fieldName === 'financeAccessEmployeeIds') {
            // Parse the oldValue safely
            let oldValueIds: any;
            try {
              oldValueIds = JSON.parse(ele.oldValue);
            } catch (error) {
              console.error('Invalid JSON in oldValue:', ele.oldValue, error);
              return;
            }

            // Match IDs and extract names for oldValue
            const matchingEmployees = this.EmployeeSummaryData
              .filter((employee: { id: any }) => oldValueIds.includes(employee.id))
              .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

            ele.oldValue = matchingEmployees;

            // Parse the newValue safely
            let newValueIds: any;
            try {
              newValueIds = JSON.parse(ele.newValue);
            } catch (error) {
              console.error('Invalid JSON in newValue:', ele.newValue, error);
              return;
            }

            // Match IDs and extract names for newValue
            const matchingNewEmployees = this.EmployeeSummaryData
              .filter((employee: { id: any }) => newValueIds.includes(employee.id))
              .map((employee: { firstName: string; lastName: string }) => `${employee.firstName.trim()} ${employee.lastName.trim()}`);

            ele.newValue = matchingNewEmployees;
          }
        });

       
      });
  }



  //Delete Log
  viewDeleteLogsDetails() {
    this.httpService.callGetService(`${this.config.viewLogsForAssetDeleted}/${this.loggedInUserCompanyID}/${this.selectedYearForCompetency}`)
      .subscribe((result: any) => {
        this.deleteLogsData = []
        const authorities = result.data.deletedAuthorities || [];
        const assets = result.data.deletedAssets || [];
        this.deleteLogsData = [...authorities, ...assets];

      })
  }
}
